import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { useTheme } from "../ThemeContext";

import GenerateScanLink from "./GenerateScanLink";
import DomainScanners from "./DomainScanners";
import LWidget from "./LWidgetCreator";
import "./LDomainScan.css";

const ScanTabs = () => {
  const { isDarkMode } = useTheme();
  const [active, setActive] = useState("domain");

  return (
    <Card className={`scan-card ${isDarkMode ? "bg-dark" : "light"}`}>
      {/* Tabs Header */}
      <div className="scan-tabs">
        <button
          className={`scan-tab ${active === "domain" ? "active" : ""}`}
          onClick={() => setActive("domain")}
        >
          🔍 External Risk Scan
        </button>

        <button
          className={`scan-tab ${active === "generate" ? "active" : ""}`}
          onClick={() => setActive("generate")}
        >
          🔗 Generate Scan Link
        </button>
        <button
          className={`scan-tab ${active === "widget" ? "active" : ""}`}
          onClick={() => setActive("widget")}
        >
          🧩 Attack Surface Lead Magnet
        </button>


      </div>

      {/* Content (components stay mounted) */}
      <div className={`scan-content ${isDarkMode ? "bg-dark" : "light"}`}>
        <motion.div
          animate={{ opacity: active === "domain" ? 1 : 0, y: active === "domain" ? 0 : 10 }}
          style={{ display: active === "domain" ? "block" : "none" }}
          transition={{ duration: 0.25 }}
        >
          <DomainScanners />
        </motion.div>

        <motion.div
          animate={{ opacity: active === "generate" ? 1 : 0, y: active === "generate" ? 0 : 10 }}
          style={{ display: active === "generate" ? "block" : "none" }}
          transition={{ duration: 0.25 }}
        >
          <GenerateScanLink />
          
        </motion.div>
        <motion.div
          animate={{ opacity: active === "widget" ? 1 : 0, y: active === "widget" ? 0 : 10 }}
          style={{ display: active === "widget" ? "block" : "none" }}
          transition={{ duration: 0.25 }}
        >
          <LWidget />
        </motion.div>
      </div>
    </Card>
  );
};

export default ScanTabs;
